/* global window */

// Set at container start by nginx (/config.js, from env vars). Fall back to staging.
export const DONKEY_API_URL = window.DONKEY_API_URL || "https://donkey-api.staging.finvia.fo";
export const AUTH0_DOMAIN = window.AUTH0_DOMAIN || "id.staging.finvia.fo";
export const AUTH0_CLIENT_ID = window.AUTH0_CLIENT_ID || "REPLACE_WITH_DONKEY_EXCELADDIN_CLIENT_ID";
